import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

const Roles = Object.freeze({
  /** @type {1} */ Usuario: 1,
  /** @type {2} */ Administrador: 2,
  /** @type {3} */ SuperAdministrador: 3,
  /** @type {4} */ UsuarioConsulta: 4,
  /** @type {4} */ Servicio: 5,
  /** @type {4} */ ServicioSuperAdmin: 6,
  /** @type {7} */ AdminDistribuidor: 7,
  /** @type {8} */ SuperAdminDistribuidor: 8,
  /** @type {9} */ Proveedor: 9
})

function GenerateConfig () {
  return [
    {
      id: Roles.UsuarioConsulta,
      name: i18n.t('tipos.roles.usuario_consulta'),
    },
    {
      id: Roles.Usuario,
      name: i18n.t('tipos.roles.usuario'),
    },
    {
      id: Roles.Administrador,
      name: i18n.t('tipos.roles.administrador'),
    },
    {
      id: Roles.AdminDistribuidor,
      name: i18n.t('tipos.roles.admin_distribuidor'),
      only: [Roles.AdminDistribuidor, Roles.SuperAdminDistribuidor, Roles.SuperAdministrador]
    },
    {
      id: Roles.SuperAdminDistribuidor,
      name: i18n.t('tipos.roles.super_admin_distribuidor'),
      only: [Roles.SuperAdminDistribuidor, Roles.SuperAdministrador]
    },
    {
      id: Roles.SuperAdministrador,
      name: i18n.t('tipos.roles.super_administrador'),
      only: [Roles.SuperAdministrador]
    },
    {
      id: Roles.Proveedor,
      name: i18n.t('tipos.roles.proveedor'),
    },
  ]
}

export function ROLES (state) {
  return configHelper.getConfig(state, 'ROLES', GenerateConfig)
}

export default Roles
export { Roles }
